<template>
  <div id="listAvailEquipment">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title">Available Equipment</div>

            <div class="web-action-btn">
              <div class="btn-groups text-right">
                  <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                      <i class="fp-export"></i> Export
                  </a>

              </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="admin-page-content available-equipment-lists">
            <data-table-filter-config :moduleName="'availableEquipmentReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'availableEquipmentReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Available Equipment Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "AvailableEquipmentReport",
    
    metaInfo(){
       return {
         title : 'Available Equipment Report | FleetPro Application'
       }
    },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      action : 'list',
      cantAccessPage:"",
      permissions:[],
      loading: false,
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns: [
                {
                    label: 'Unit #',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    // sortable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manuf.',
                    field: 'manufacturer_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'model',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Equip Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Equipment Type Description',
                    field: 'asset_type_desc',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Equipment Type Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'GVW',
                    field: 'gross_weight',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "GVW", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Physical Location',
                    field: 'physical_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Physical Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pool',
                    field: 'pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract #',
                    field: 'contract_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'LTD Reading',
                    field: 'ltd_reading',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ltd Reading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Metric Type',
                    field: 'metric_type',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Metric Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'OOS',
                    field: 'currently_wo',
                    fpFieldType:"option",
                    // sortable: false,
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "OOS", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Y','N'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                  label: "OOS Date",
                  field: "open_date",
                  filterable: true,
                  fpFieldType:"custom_date",
                  hidden:false,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'For Sale',
                  field: 'on_sale',
                  hidden:false,
                  fpFieldType:"option",
                  filterable: true,
                  // sortable: false,
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y','N'],
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter", //only trigger on enter not on keyup
                  },
                },
                {
                    label: 'Date For Sale',
                    field: 'dt_for_sale',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Parent Unit',
                    field: 'parent_unit',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Parent Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable : false,
                },
                {
                  label: 'Reserved',
                  field: 'reserved',
                  hidden:false,
                  fpFieldType:"option",
                  filterable: true,
                  // sortable: false,
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y','N'],
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter", //only trigger on enter not on keyup
                  },
                },
                {
                    label: 'Reserved To Date',
                    field: "reserved_date",
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "reserved_date", // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Feature 1',
                    field: 'feature_1',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Feature 1", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false,
                },
                {
                    label: 'Feature 2',
                    field: 'feature_2',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Feature 3',
                    field: 'feature_3',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Feature 3", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Customer Number',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Name',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
      batchProcess:0,
      batchNum:"",

      }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'available_equipment_report') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
   methods:{
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/available-equipment-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" ) {
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
                  self.action = "list";
                  // self.loadList();
                  return;

            } else {
                  if (data.content.row != undefined) {
                    self.rows = data.content.row;
                  }

                  self.totalRecords = data.content.totalRecords;

            }

          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'available-equipment-report')
        }
      });


    }
  }




  }
</script>



// WEBPACK FOOTER //
// src/components/reports/AvailableEquipmentReport.vue